import { auth } from "@/firebase";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";

const authen = {
  namespaced: true,
  state: {
    user: null,
  },
  getters: {},
  mutations: {
    SET_USER_AUTHENTICATION(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    async signin({ dispatch }, payload) {
      return setPersistence(auth, browserLocalPersistence)
        .then(() => {
          return signInWithEmailAndPassword(
            auth,
            payload.email,
            payload.password,
          );
        })
        .then(async (userCredential) => {
          // 👇 Reload ข้อมูลผู้ใช้หลัง login สำเร็จ
          await auth.currentUser.reload();

          // 👇 dispatch setUserProfile เพื่ออัปเดต Vuex ทันที
          dispatch("setUserProfile", auth.currentUser);

          return userCredential;
        })
        .catch((error) => {
          dispatch("utils/handleHttpError", error, { root: true });
          throw error;
        });
    },

    // async signout({ commit }) {
    //   await signOut(auth).then(() => {
    //     commit("SET_USER_AUTHENTICATION", null);
    //   });
    // },
    async signout({ commit }) {
      await signOut(auth).then(() => {
        // 1. เคลียร์ข้อมูลสิทธิ์ผู้ใช้ใน Vuex
        commit("SET_USER_AUTHENTICATION", null);

        // 2. เคลียร์ค่าสินค้าล่าสุดที่เคยบันทึกไว้ (จากในหน้าคอมโพเนนต์ก่อนหน้า)
        localStorage.removeItem("last_product_id");

        // 3. (แนะนำเพิ่มเติม) หากมี Vuex Module ของตะกร้าสินค้า ควรเคลียร์ด้วย
        // commit("cart/CLEAR_CART", null, { root: true }); // ตัวอย่าง

        console.log("👋 ออกจากระบบและล้างข้อมูลในเครื่องเรียบร้อย");
      });
    },

    setUserProfile({ commit }, userAuthen) {
      let profile;
      try {
        profile = JSON.parse(userAuthen.displayName);
      } catch (e) {
        // ถ้า parse ไม่ได้ ให้เก็บเป็น object มี field ชื่อ displayName แทน
        profile = {
          displayName: userAuthen.displayName || "",
          uid: userAuthen.uid,
        };
      }
      profile.uid = userAuthen.uid;
      profile.employeeCode = profile.id || "";
      profile.email = userAuthen.email;

      commit("SET_USER_AUTHENTICATION", profile);
    },

    fetchUser({ dispatch }) {
      try {
        auth.onAuthStateChanged(async (user) => {
          if (user) {
            // 🔥 บังคับดาวน์โหลดสถานะล่าสุดจาก Firebase Server ใหม่ทีก่อนอัปเดต
            await user.reload();

            // ส่งข้อมูลผู้ใช้หลังจากรีโหลดเรียบร้อยแล้วไปเก็บใน Vuex
            dispatch("setUserProfile", auth.currentUser);
            return;
          } else {
            dispatch("signout");
          }
        });
      } catch (e) {
        console.log(e);
      }
    },

    // fetchUser({ dispatch }) {
    //   try {
    //     auth.onAuthStateChanged((user) => {
    //       if (user) {
    //         dispatch("setUserProfile", user);

    //         return;
    //       } else {
    //         dispatch("signout");
    //       }
    //     });
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },

    async createAuthenUser(_, profile) {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        profile.email,
        profile.password,
      );

      return userCredential;
    },

    async sendEmailVerify(_, userCredential) {
      sendEmailVerification(userCredential.user);
    },

    async updateProfileUser(_, profile) {
      const registerData = profile;

      updateProfile(auth.currentUser, {
        displayName: JSON.stringify(registerData),
      });
    },

    async resetPassword({ dispatch }, email) {
      await sendPasswordResetEmail(auth, email)
        .then(() => {
          dispatch(
            "utils/alertSuccess",
            {
              message:
                "ระบบทำการส่งลิงค์เปลี่ยน Password ไปยัง Email Address ของคุณแล้วค่ะ",
            },
            { root: true },
          );
        })
        .catch((e) => {
          dispatch("utils/handleHttpError", e, { root: true });
        });
    },
  },
};

export { authen };
